export default class DateUtils {

    static getDateString(date: Date): string {
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
    }

    static getDateAsNumber(date: Date): number {
        return date.getTime()
    }
}



// WEBPACK FOOTER //
// ./src/utils/DateUtils.ts